import { createContext, useContext, useEffect, useState } from "react";
import { getAuth, getConfig } from '../api/allauth';
import { AuthLoading } from "./AuthLoading";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(undefined);
    const [config, setConfig] = useState(undefined);

    useEffect(() => {
        function onAuthChanged(e) {
            setAuth(e.detail);
        }

        document.addEventListener("allauth.auth.change", onAuthChanged);

        Promise.all([getAuth(), getConfig()])
            .then(([authData, configData]) => {
                setAuth(authData);
                setConfig(configData);
            })
            .catch((err) => {
                setAuth(null);
                setConfig(null);
            });

        return () =>
            document.removeEventListener("allauth.auth.change", onAuthChanged);
    }, []);

    const loading = auth === undefined || config === undefined;

    if (loading) {
        return <AuthLoading />;
    }

    return (
        <AuthContext.Provider value={{ auth, config }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

export function authInfo(auth) {
    if (!auth) return { isAuthenticated: false };

    const isAuthenticated =
        auth.status === 200 ||
        (auth.status === 401 && auth.meta?.is_authenticated);

    return { isAuthenticated };
}

export function useAuthStatus() {
    const { auth } = useAuth();
    return [auth, authInfo(auth)];
}

export function useConfig() {
    const { config } = useAuth();
    return config;
}
